"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasDefectsNotificationPeriod = hasDefectsNotificationPeriod;
exports.ContractModalBodyStatus = ContractModalBodyStatus;
exports.ContractModalBodyName = ContractModalBodyName;
exports.ContractModalBodyDates = ContractModalBodyDates;
exports.OptionalContractDateFields = OptionalContractDateFields;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const FormContext_1 = require("../../../View/Modals/FormContext");
const ToolsForms_1 = __importDefault(require("../../../React/Tools/ToolsForms"));
const ToolsDate_1 = __importDefault(require("../../../React/Tools/ToolsDate"));
const StatusSelectors_1 = require("../../../View/Modals/CommonFormComponents/StatusSelectors");
const GenericComponents_1 = require("../../../View/Modals/CommonFormComponents/GenericComponents");
/**
 * Czy umowa ma Okres Zgłaszania Wad (FIDIC DNP). Instytucja występuje wyłącznie w umowach
 * na roboty w trybie Żółtym i Czerwonym — dla pozostałych typów pole nie ma sensu i nie
 * pokazujemy go wcale.
 *
 * ŚWIADOMA ROZBIEŻNOŚĆ wobec filtra integracji z FIDmanem, który pyta o `TypeId` z allowlisty
 * syncu. To dwa różne pytania: tutaj domenowe („czy ta umowa w ogóle ma taki termin"), tam
 * techniczne („czy system wyśle ją do FIDmana"). Dlatego tu po pierwszym słowie nazwy typu —
 * tak samo jak ContractTypeBadge wyprowadza kolor — i dlatego „Czerwony ryczałtowy" DOSTAJE
 * to pole, choć do FIDmana dziś nie idzie. Nie ujednolicać obu miejsc bez nowej decyzji.
 *
 * Skutek uboczny do zapamiętania: zmiana typu umowy na taki bez OZW ukrywa pole, ale NIE
 * kasuje wpisanej wcześniej daty w bazie. Dane zostają — zamierzone.
 */
function hasDefectsNotificationPeriod(type) {
    const firstWord = (type?.name ?? "").trim().split(/\s+/)[0];
    return firstWord === "Czerwony" || firstWord === "Żółty";
}
function ContractModalBodyStatus({ initialData }) {
    const { setValue, register, formState: { errors }, } = (0, FormContext_1.useFormContext)();
    (0, react_1.useEffect)(() => {
        setValue("status", initialData?.status || "", { shouldValidate: true });
    }, [initialData, setValue]);
    return react_1.default.createElement(StatusSelectors_1.ContractStatusSelector, null);
}
function ContractModalBodyName({ initialData }) {
    const { setValue, register, formState: { errors }, } = (0, FormContext_1.useFormContext)();
    (0, react_1.useEffect)(() => {
        setValue("name", initialData?.name || "", { shouldValidate: true });
    }, [initialData, setValue]);
    return (react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: "name" },
        react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Nazwa kontraktu"),
        react_1.default.createElement(react_bootstrap_1.Form.Control, { as: "textarea", rows: 2, placeholder: "Podaj nazw\u0119", isInvalid: !!errors?.name, isValid: !errors?.name, ...register("name") }),
        react_1.default.createElement(GenericComponents_1.ErrorMessage, { errors: errors, name: "name" })));
}
function ContractModalBodyDates({ initialData, isEditing, additionalProps = {}, }) {
    const { setValue, register, formState: { errors }, trigger, watch, } = (0, FormContext_1.useFormContext)();
    let { watchAllFieldsExternal, startDateSugestion, endDateSugestion, guaranteeEndDateSugestion } = additionalProps;
    //jeśli nie ma watch w formularzu zewnętrznym to będzie tutaj
    const watchAllFields = watchAllFieldsExternal || watch();
    if (isEditing) {
        startDateSugestion = initialData?.startDate;
        endDateSugestion = initialData?.endDate;
        guaranteeEndDateSugestion = initialData?.guaranteeEndDate;
    }
    else {
        startDateSugestion = new Date().toISOString().slice(0, 10);
        endDateSugestion = ToolsDate_1.default.addDays(startDateSugestion, 365).toISOString().slice(0, 10);
        guaranteeEndDateSugestion = ToolsDate_1.default.addDays(endDateSugestion, 365 * 2)
            .toISOString()
            .slice(0, 10);
    }
    (0, react_1.useEffect)(() => {
        setValue("startDate", startDateSugestion, { shouldValidate: true });
        setValue("endDate", endDateSugestion, { shouldValidate: true });
        setValue("guaranteeEndDate", guaranteeEndDateSugestion, { shouldValidate: true });
        // Terminy nieobowiązkowe: pusty string, gdy ich nie ma. Nie `undefined` — pole
        // niekontrolowane przeszłoby w kontrolowane przy pierwszym wpisaniu daty i React
        // zgłosiłby ostrzeżenie; pusty string trzyma je kontrolowanym od początku.
        setValue("warrantyEndDate", initialData?.warrantyEndDate ?? "", { shouldValidate: true });
        setValue("defectsNotificationEndDate", initialData?.defectsNotificationEndDate ?? "", {
            shouldValidate: true,
        });
    }, [initialData, setValue]);
    return (react_1.default.createElement(react_bootstrap_1.Row, null,
        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Col, controlId: "startDate" },
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Pocz\u0105tek"),
            react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "date", isValid: !errors.startDate, isInvalid: !!errors.startDate, ...register("startDate"), className: !isEditing ? ToolsForms_1.default.getSuggestedClass("startDate", watchAllFields, startDateSugestion) : "", onChange: (e) => {
                    register("startDate").onChange(e); // wywołaj standardowe zachowanie
                    trigger("endDate");
                } }),
            react_1.default.createElement(GenericComponents_1.ErrorMessage, { errors: errors, name: "startDate" })),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Col, controlId: "endDate" },
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Zako\u0144czenie"),
            react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "date", isValid: !errors.endDate, isInvalid: !!errors.endDate, ...register("endDate"), className: !isEditing ? ToolsForms_1.default.getSuggestedClass("endDate", watchAllFields, endDateSugestion) : "", onChange: (e) => {
                    register("endDate").onChange(e); // wywołaj standardowe zachowanie
                    trigger("startDate");
                    trigger("guaranteeEndDate");
                } }),
            react_1.default.createElement(GenericComponents_1.ErrorMessage, { errors: errors, name: "endDate" })),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Col, controlId: "guaranteeEndDate" },
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Gwarancja"),
            react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "date", isValid: !errors.guaranteeEndDate, isInvalid: !!errors.guaranteeEndDate, ...register("guaranteeEndDate"), className: !isEditing
                    ? ToolsForms_1.default.getSuggestedClass("guaranteeEndDate", watchAllFields, guaranteeEndDateSugestion)
                    : "", onChange: (e) => {
                    register("guaranteeEndDate").onChange(e); // wywołaj standardowe zachowanie
                    //trigger("startDate");
                } }),
            react_1.default.createElement(GenericComponents_1.ErrorMessage, { errors: errors, name: "guaranteeEndDate" })),
        react_1.default.createElement(OptionalContractDateFields, { type: initialData?._type })));
}
/**
 * Terminy nieobowiązkowe: rękojmia (każda umowa) i koniec Okresu Zgłaszania Wad (tylko Żółty
 * i Czerwony — zob. hasDefectsNotificationPeriod).
 *
 * Świadomie BEZ wartości podpowiadanej i bez `ToolsForms.getSuggestedClass`, inaczej niż przy
 * gwarancji obok. Podpowiedź w polu, którego wolno nie wypełnić, zamienia „nie ustalono" na
 * „wpisano datę wziętą z sufitu” — a te terminy trafiają potem do pilnowania zobowiązań.
 * Pusto ma znaczyć pusto.
 */
function OptionalContractDateFields({ type }) {
    const { register, formState: { errors }, } = (0, FormContext_1.useFormContext)();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Col, controlId: "warrantyEndDate" },
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "R\u0119kojmia"),
            react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "date", isInvalid: !!errors.warrantyEndDate, ...register("warrantyEndDate") }),
            react_1.default.createElement(GenericComponents_1.ErrorMessage, { errors: errors, name: "warrantyEndDate" })),
        hasDefectsNotificationPeriod(type) && (react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Col, controlId: "defectsNotificationEndDate" },
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Zg\u0142aszanie wad do"),
            react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "date", isInvalid: !!errors.defectsNotificationEndDate, ...register("defectsNotificationEndDate") }),
            react_1.default.createElement(GenericComponents_1.ErrorMessage, { errors: errors, name: "defectsNotificationEndDate" })))));
}
